var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayRoundedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ACFBCD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#CFFFE3",
    strokeWidth: 5.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9801 25.6673C22.662 25.6673 25.6468 22.6825 25.6468 19.0007C25.6468 15.3188 22.662 12.334 18.9801 12.334C15.2982 12.334 12.3135 15.3188 12.3135 19.0007C12.3135 22.6825 15.2982 25.6673 18.9801 25.6673Z",
    stroke: "#009642",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8271 19.1537V18.0404C16.8271 16.6537 17.8071 16.0871 19.0071 16.7804L19.9738 17.3404L20.9405 17.9004C22.1405 18.5937 22.1405 19.7271 20.9405 20.4204L19.9738 20.9804L19.0071 21.5404C17.8071 22.2337 16.8271 21.6671 16.8271 20.2804V19.1537Z",
    stroke: "#009642",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayRoundedGreen);
export default __webpack_public_path__ + "static/media/play-rounded-green.dad1425335282d1d45a32ae1ffd6ed96.svg";
export { ForwardRef as ReactComponent };